import {
  ICommonSaveActionType,
  ICommonSavePayload,
  ICommonSearchActionType,
} from '../Common.actions';
import {createAction} from '@reduxjs/toolkit';
import {ISearchRequest} from '../../types/common/SearchRequest';
import {IPagedResult} from '../../types/common/PagedResult';
import {IScorecardParamsModel} from '../../types/requests/ScorecardParamsModel';
import {ISaveScorecardPresetsModel} from '../../types/requests/SaveScorecardPresetsModel';
import {IScorecardPresetModel} from '../../types/models/ScorecardPresetModel';
import {IPersonSearchResultModel} from '../../types/views/PersonSearchResultModel';
import {IRetrieveScorecardPresetsModel} from '../../types/requests/RetrieveScorecardPresetsModel';
import {STUDENT} from '../students/Actions';


export interface IDashboardPresetTypes extends ICommonSaveActionType {
  DELETE: string,
  REFRESH: string,
}

export interface IRecruitmentScorecardTypes extends ICommonSearchActionType {

}

export interface IEngagementScorecardTypes extends ICommonSearchActionType {

}

export interface IInternshipScorecardTypes extends ICommonSearchActionType {

}

export interface ICompanyInternshipScorecardTypes extends ICommonSearchActionType {

}

export const DASHBOARD_PRESET: IDashboardPresetTypes = {
  LOAD: 'dashboardPreset/load',
  LOADED: 'dashboardPreset/loaded',
  LOAD_ERROR: 'dashboardPreset/loadError',
  SAVE: 'dashboardPreset/save',
  SAVED: 'dashboardPreset/saved',
  SAVE_ERROR: 'dashboardPreset/saveError',
  DELETE: 'dashboardPreset/delete',
  REFRESH: 'dashboardPreset/refresh',
}

export const PROFILE_READY_DASHBOARD: IRecruitmentScorecardTypes = {
  LOAD: 'profileReadyDashboard/load',
  LOADED: 'profileReadyDashboard/loaded',
  ERROR: 'profileReadyDashboard/search',
  CHANGE_VIEW: 'profileReadyDashboard/changeView',
  REFRESH: 'profileReadyDashboard/refresh',
};

export const SENT_TO_EMPLOYER_DASHBOARD: IEngagementScorecardTypes = {
  LOAD: 'sentToEmployerDashboard/load',
  LOADED: 'sentToEmployerDashboard/success',
  ERROR: 'sentToEmployerDashboard/search',
  CHANGE_VIEW: 'sentToEmployerDashboard/changeView',
  REFRESH: 'sentToEmployerDashboard/refresh',
};

export const INTERVIEW_BOOKED_DASHBOARD: IInternshipScorecardTypes = {
  LOAD: 'interviewBookedDashboard/load',
  LOADED: 'interviewBookedDashboard/success',
  ERROR: 'interviewBookedDashboard/search',
  CHANGE_VIEW: 'interviewBookedDashboard/changeView',
  REFRESH: 'interviewBookedDashboard/refresh',
};


export const dashboardPresetSave = createAction<ISaveScorecardPresetsModel>(DASHBOARD_PRESET.SAVE);
export const dashboardPresetSaveSuccess = createAction(DASHBOARD_PRESET.SAVED);
export const dashboardPresetSaveError = createAction<string>(DASHBOARD_PRESET.SAVE_ERROR);
export const dashboardPresetLoad = createAction<IRetrieveScorecardPresetsModel>(DASHBOARD_PRESET.LOAD);
export const dashboardPresetLoadSuccess = createAction<IScorecardPresetModel[]>(DASHBOARD_PRESET.LOADED);
export const dashboardPresetLoadError = createAction<string>(DASHBOARD_PRESET.LOAD_ERROR);
export const dashboardPresetDelete = createAction<ISaveScorecardPresetsModel>(DASHBOARD_PRESET.DELETE);
export const dashboardPresetRefresh = createAction(DASHBOARD_PRESET.REFRESH);

export const profileReadyDashboardSearch = createAction<ISearchRequest<IScorecardParamsModel>>(PROFILE_READY_DASHBOARD.LOAD);
export const profileReadyDashboardSearchView = createAction<string>(PROFILE_READY_DASHBOARD.CHANGE_VIEW);
export const profileReadyDashboardSearchRefresh = createAction<ISearchRequest<IScorecardParamsModel>>(PROFILE_READY_DASHBOARD.REFRESH);
export const profileReadyDashboardSearchError = createAction<string>(PROFILE_READY_DASHBOARD.ERROR);
export const profileReadyDashboardSearchSuccess = createAction<IPagedResult<IPersonSearchResultModel>>(PROFILE_READY_DASHBOARD.LOADED);

export const sentToEmployerDashboardSearch = createAction<ISearchRequest<IScorecardParamsModel>>(SENT_TO_EMPLOYER_DASHBOARD.LOAD);
export const sentToEmployerDashboardSearchView = createAction<string>(SENT_TO_EMPLOYER_DASHBOARD.CHANGE_VIEW);
export const sentToEmployerDashboardSearchRefresh = createAction<ISearchRequest<IScorecardParamsModel>>(SENT_TO_EMPLOYER_DASHBOARD.REFRESH);
export const sentToEmployerDashboardSearchError = createAction<string>(SENT_TO_EMPLOYER_DASHBOARD.ERROR);
export const sentToEmployerDashboardSearchSuccess = createAction<IPagedResult<IPersonSearchResultModel>>(SENT_TO_EMPLOYER_DASHBOARD.LOADED);

export const interviewBookedDashboardSearch = createAction<ISearchRequest<IScorecardParamsModel>>(INTERVIEW_BOOKED_DASHBOARD.LOAD);
export const interviewBookedDashboardSearchView = createAction<string>(INTERVIEW_BOOKED_DASHBOARD.CHANGE_VIEW);
export const interviewBookedDashboardSearchRefresh = createAction<ISearchRequest<IScorecardParamsModel>>(INTERVIEW_BOOKED_DASHBOARD.REFRESH);
export const interviewBookedDashboardSearchError = createAction<string>(INTERVIEW_BOOKED_DASHBOARD.ERROR);
export const interviewBookedDashboardSearchSuccess = createAction<IPagedResult<IPersonSearchResultModel>>(INTERVIEW_BOOKED_DASHBOARD.LOADED);

